import React, { Component, PropTypes } from 'react';

import { NitroLinks } from 'nitro-components';

import ExportDrawer from './ExportDrawer';

import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
`

class ActionLinks extends Component {

  constructor(props) {
    super(props);
    this.state = {
      exportOpen: false
    };
  }

  openExport = () => {
    
    this.setState({
      exportOpen: true
    });
  }

  closeExport = () => {
    this.setState({
      exportOpen: false
    });
  }
  
  render () {

    const { exportChart, exportCSV, align } = this.props;

    const actionLinks = [
      {label: 'Export', icon: 'export', action: this.openExport}
    ];
    return (
      <Wrapper>
        <NitroLinks layout="horizontal" data={actionLinks} align={align} />
        <ExportDrawer exportCSV={exportCSV} exportChart={exportChart} open={this.state.exportOpen} close={this.closeExport} exportType={this.props.exportType} availableOptions={this.props.availableOptions} />
      </Wrapper>
    );
  }
}


ActionLinks.propTypes = {
  exportCSV: PropTypes.func.isRequired,
  exportChart: PropTypes.func.isRequired,
  align: PropTypes.string,
  availableOptions:PropTypes.array
};

export default ActionLinks;



// WEBPACK FOOTER //
// ./src/features/insights/components/ActionLinks.js